/**
 *
 *  Application entry point.
 *
 */


 /**
 * SCSS entry.
 */
import '../scss/style.scss';


/**
 * Dependancies
 */
import isEmpty from 'validator/lib/isEmpty';
import isEmail from 'validator/lib/isEmail';
import isNumeric from 'validator/lib/isNumeric';
import isAlpha from 'validator/lib/isAlpha';
import waypoint from 'waypoints/lib/jquery.waypoints.min.js';
// import slick from 'slick-carousel/slick/slick.min.js';

/**
 * App
 */
jQuery(document).ready(function($) {



	//sticky header
	if ($('.navbar-default').length >= 1 && document.documentElement.clientWidth > 768)  {
	    $(window).scroll(function() {
	      var header = $(document).scrollTop();
	      var headerHeight = $('.navbar-default').height();
	      if (header > headerHeight) {
	        $('.navbar-default').addClass('navbar-fixed-top');
	      } else{
	        $('.navbar-default').removeClass('navbar-fixed-top');
	      }
	    });
	}

	//same height
	$('.contact_map_box').css({'height':($('.contact_box_info').innerHeight()+'px')});
    $('.same_as.image_mask').css({'height':($('.this_height.svg_mask').innerHeight()+'px')});
    $('.svg_img_xl .image_mask').css({'height':($('.svg_img_xl .svg_mask').innerHeight()+'px')});

	if (document.documentElement.clientWidth > 768 ) {
	    $('header').css({'height':($('.navbar-default').innerHeight()+'px')});
	}

	//prevent scroll when mobile menu is open
	$('.navbar-toggle').click(function(){
		$('.dialog-off-canvas-main-canvas').toggleClass('freeze');
	});

	$('.lg_drop').click(function(){
		if($('.navbar-collapse').hasClass('in')){
			$('.navbar-collapse').removeClass('in').attr('aria-expanded','false');
			$('.navbar-toggle').addClass('collapsed').attr('aria-expanded','false');
			$('.dialog-off-canvas-main-canvas').removeClass('freeze');
		}
	});

	$('.navbar-toggle').click(function(){
		if($('.lg_drop').hasClass('open')){
			$(this).removeClass('open');
			$('.dropdown-toggle').attr('aria-expanded','false');
		}
	});

	//mobile share open

	$('.mobile_share_btn, .mobile_share a').click(function(){
		$('.mobile_share').toggleClass('open');
		$('.mobile_share_list').toggleClass('hide');
	});

	//check which is higher and apply it to siblings
	$(document).ready(function() {
	  // Get an array of all element heights
	  var elementHeightsIntro = $('.intro_box_item h2').map(function() {
	    return $(this).height();
	  }).get();
	  var elementHeightsChiffres = $('.chiffres_cles_box .slick-slide .inner_content').map(function() {
	    return $(this).height();
	  }).get();
	   var elementHeightsReport = $('.reporting-item').map(function() {
	    return $(this).height();
	  }).get();
	   var elementHeightsBlogTitle = $('.blog-item-title').map(function() {
	    return $(this).height();
	  }).get();
	   var elementHeightsBlogTag = $('.blog-item-tag').map(function() {
	    return $(this).height();
	  }).get();
	  // Math.max takes a variable number of arguments
	  // `apply` is equivalent to passing each height as an argument
	  var maxHeightIntro = Math.max.apply(null, elementHeightsIntro);
	  var maxHeightChiffres = Math.max.apply(null, elementHeightsChiffres);
	  var maxHeightReport = Math.max.apply(null, elementHeightsReport);
	  var maxHeightTitle = Math.max.apply(null, elementHeightsBlogTitle);
	  var maxHeightTag = Math.max.apply(null, elementHeightsBlogTag);
	  // Set each height to the max height
	  if (document.documentElement.clientWidth > 767 ) {
			$('.intro_box_item h2').height(maxHeightIntro);
			$('.chiffres_cles_box .slick-slide .inner_content').height(maxHeightChiffres);
			$('.reporting-item').height(maxHeightReport);
			$('.blog-item-title').height(maxHeightTitle);
			$('.blog-item-tag').height(maxHeightTag);
		}

	});

	//trigger animation
	var ib_item = $('.intro_box_item');

	ib_item.waypoint(function() {
		ib_item.each(function(){
			ib_item.addClass('flipInX');
		})
	}, {offset: '75%'});


	var sol_list = $('.solutions_liste');

	sol_list.waypoint(function() {
		var sl_item = $('.solutions_liste li')
			sl_item.addClass('flipInX');
	}, {offset: '75%'});

	var vb_item = $('.valeurs_box_item');

	vb_item.waypoint(function() {
		vb_item.each(function(){
			vb_item.addClass('flipInX');
		})
	}, {offset: '75%'});


	var pb_items = $('.piliers_box');

	pb_items.waypoint(function() {
		var pb_item = $('.piliers_box .piliers_item');
		pb_items.each(function(){
			pb_item.addClass('flipInX');
		})
	}, {offset: '75%'});


	var i_item = $('.icone_box');

	i_item.waypoint(function() {
		i_item.each(function(){
			i_item.addClass('flipInX');
		})
	}, {offset: '75%'});

	var ch_item = $('.chiffre_cle .count');


	//hide or show the faq link
	$(window).scroll(function(){
		if ($(window).scrollTop() > 200){
			$('.faq_btn').addClass("show");
		}
		else{
			$('.faq_btn').removeClass("show");
		}
	});

	var headerHeight = $('.header').innerHeight();

	$(window).scroll(function() {
		var stickySocial = $('.stick_social');
		if(stickySocial.length){
			var stickyIcky = stickySocial.offset().top;
		    if ($(window).scrollTop() > stickyIcky) {
		        $('.social_share_wrap').addClass('stickyicky');
		    }
		    else {
		        $('.social_share_wrap').removeClass('stickyicky');
		    }
		}
	});

	if($('body').hasClass('path-recherche')){
		$('.search_bar_btn').attr('disabled','').children().addClass('disactive');
	}

	if( $('body').hasClass('path-user') && $('form').hasClass('user-login-form')){
		$('.navbar-btn.link_menu_space').attr({'disabled':'','data-target':''}).addClass('disactive');
	}

	if( $('body').hasClass('path-user') && !$('form').hasClass('user-login-form')){
		$('.navbar-btn.link_menu_space').attr({'href':'/user/login','data-target':''});
	}

	//search bar trigger
	$(document).on('click', '.search_bar_btn', function(){
		$('.search_bar_btn').toggleClass('active');
		$('.search_block_bar').toggleClass('scroll_down');
		setTimeout(function(){
			$('.search_header_input').focus();
		}, 100);
		$('.search_header_input').val('');
	});

	$(document).on('click', '.close_search_bar', function(){
		$('.search_block_bar').removeClass('scroll_down');
		$('.views-exposed-form .form-text').val('');
		$('.search_bar_btn').removeClass('active');
	});

	//custom select
	$('.custom-select .select-items div').click(function(){
    	$('.select-selected').addClass('selected_choice');
    });

    $('.custom-select .select-selected').click(function(){
    	console.log($('.custom-select select option:first-child').text());
    	if($(this).html() == $('.custom-select select option:first-child').text()){
    		$(this).removeClass('selected_choice');
    	}
    	else if($('.select-items').hasClass('select-hide')){
    		$('.select-selected').addClass('selected_choice');
    	}else{
    		$('.select-selected').removeClass('selected_choice');
    	}
    });

	$('.custom-select .select-wrapper .select-selected').click(function(){
		$('.custom-select .select-wrapper').toggleClass('stretch_out');
	});

	$('body').click(function(){
		if($('.custom-select .select-wrapper').hasClass('stretch_out')){
			$('.custom-select .select-wrapper').removeClass('stretch_out');
		}
	});

	// get url
	function updateURL() {
		let paramName = $('#edit-keyword').val();
		const params = new URLSearchParams(location.search);
		params.set('keyword', paramName);
		window.history.replaceState({}, '', `${location.pathname}?${params}`);
	}

	$('#edit-submit-aaa-recherche').click(function(){
		updateURL();
	});

	$('#edit-submit-aaa-recherche').keypress(function(event){
		if(event.which == 13){
			updateURL();
		}
	});

	// get tax name and activate link

	if($('.main-container').hasClass('page_tax')){
		var taxTitle = $('.tax_title').attr('data-tax').trim();
		$('.thematique-button').each(function(i,el){
			var el = $(this).children();
			if(el.html().trim() == taxTitle ){
				el.addClass('active');
				el.attr('href', '#');
			}
		})
	}

	// activate news link
	if($('body').hasClass('path-taxonomy')){
		var target = $('a[data-drupal-link-system-path="node/66"]');
		target.parent('li').addClass('active');
	}

	//floating labels
	function liftLabel(target){
		var input = $(target);
		if(input.val().length){
			input.parent().next().addClass('lift');
		}else{
			input.parent().next().removeClass('lift');
		}
	}

	$(document).ready(function(){
		if( $('body').hasClass('path-user') ){
			liftLabel($('input[type="password"]'));
			var input = $('input.form-tel');
			if(input.val().length){
				input.next().removeClass('pull').addClass('lift');
			}else{
				input.next().removeClass('lift').addClass('pull');
			}
		}
	});

	$('input[type="password"]').keydown(function(){
		$(this).parent().next().addClass('lift');
	});

	$('input[type="password"]').focusout(function(){
		liftLabel($(this));
	});

	$('.user-login-form #edit-pass').click(function(){
		$('.user-login-form #edit-pass').parent().next().addClass('lift');
	});

	$('.user-pass-reset .form-text').click(function(){
		$(this).parent().next().addClass('lift');
	});

	$('.user-pass-reset .form-text').focusout(function(){
		liftLabel($(this));
	});

	$('.user_pass_edit .btn, .navbar-btn.link_menu_space').click(function(){
		liftLabel($('input[type="password"]'));
	});

	$('input').each(function(){
		var input = $(this);
		var label = $(this).next();
		if(input.val().length){
			label.removeClass('pull').addClass('lift');
		};
		input.click(function(){
			label.removeClass('pull').addClass('lift');
		});
		input.focus(function(){
			label.removeClass('pull').addClass('lift');
		});
		input.focusout(function(){
			if(input.val().length){
				label.removeClass('pull').addClass('lift');
			}else{
				label.removeClass('lift').addClass('pull');
			}
		});
	});

	$('input[type="email"]').focusout(function(){
		if(!isEmpty($(this).val())){
			$(this).next().removeClass('pull').addClass('lift');
		}else{
			$(this).next().removeClass('lift').addClass('pull');
		}
	});

	/**
	 *
	 */
	var nameCheck = /^([a-z àâçéèêëîïôûùüÿñæœ'\-,])+$/i,
		telCheck = /^\+*([()0-9.\- ]{10,})+$/i,
		userNameCheck = /^([a-z_@.]+)$/i;

	/**
	 * Clear all error & infos messages on the target element
	 * @param {*} target
	 */
	function validate_clearFieldMessages(target) {
		let parent = target.closest('.form-item');
		parent.removeClass('valid_input required_input invalid_input has-error diff_input');
		parent.next('.error_msg').empty();
	}

	function validate_mp_clearFieldMessages(target) {
		let parent = target.closest('.validation_row');
		parent.removeClass('valid_input required_input diff_input invalid_input');
		target.next('.error_msg').empty();
	}

	/**
	 * Set "required" error message and class
	 * @param {*} target
	 */
	function validate_setRequiredError(target) {
		let parent = target.closest('.form-item');
		parent.addClass('required_input');
		parent.next('.error_msg').empty().append(errorMessage[0]);
	}

	function validate_setInvalidError(target) {
		let parent = target.closest('.form-item');
		parent.addClass('invalid_input');
		parent.next('.error_msg').empty().append(errorMessage[1]);
	}

	function validate_setValid(target) {
		let parent = target.closest('.form-item');
		parent.addClass('valid_input');
		parent.next('.error_msg').empty();
	}

	// password functions
	function validate_mp_setRequiredError(target) {
		let parent = target.closest('.validation_row');
		parent.addClass('required_input');
		target.next('.error_msg').empty().append(errorMessage[0]);
	}

	function validate_mp_setInvalidError(target) {
		let parent = target.closest('.validation_row');
		parent.addClass('diff_input');
		target.next('.error_msg').empty().append(errorMessage[2]);
	}

	function validate_mp_setValid(target) {
		let parent = target.closest('.validation_row');
		parent.addClass('valid_input');
		target.next('.error_msg').empty();
	}


	/**
	 * Form validation
	 * @param {*} target
	 */
	function validateForm(target) {

		var isValid = true;
 		target.each(function(i, el) {
 			var el = $(this);
			var elVal = el.val();

			// Clear all feedback messages for the current field
			validate_clearFieldMessages(el);

			// Checkboxes special case
			if(el.attr('type') == 'checkbox') {
				if(el.attr('required') == 'required' && !el.prop('checked')) {
					validate_setRequiredError(el);
					isValid = false;
				} else {
					validate_setValid(el);
				}
			} else {
				// If field is not required and empty, no reason to continue further
				if(el.attr('required') != 'required' && elVal == "") {
					validate_clearFieldMessages(el);
				} else {
					// Check fields special formats
					switch(el.attr('type')) {
						case 'tel':
							if(elVal.match(telCheck)) {
								validate_setValid(el);
							} else {
								validate_setInvalidError(el);
								isValid = false;
							}
							break;
						case 'email':
							if(isEmail(elVal)) {
								validate_setValid(el);
							} else {
								validate_setInvalidError(el);
								isValid = false;
							}
							break;
						case 'text':
							if(elVal.match(nameCheck)) {
								validate_setValid(el);
							} else {
								validate_setInvalidError(el);
								isValid = false;
							}
							break;
						default:
							if(el.prop('tagName') == 'TEXTAREA') {
								if(elVal != "") {
									validate_setValid(el);
								} else {
									validate_setInvalidError(el);
									isValid = false;
								}
							}
							break;
					}

					// Check required fields
					if(el.attr('required') == 'required' && elVal == "") {
						validate_setRequiredError(el);
						isValid = false;
					}
				}

			}

		})

 		return isValid;
	}

	//contact form fields selector
	var contactFormFields = $('.contact_form input.required, .contact_form input.form-tel, .contact_form textarea, .contact_form select');

	contactFormFields.change(function(){
 		validateForm($(this));
	});

	var webformSubmissionFlag = false;
	$(".webform-submission-contact-form").submit(function(event){
		if(webformSubmissionFlag) {
			webformSubmissionFlag = false;
		} else {
			event.preventDefault();

			var trackData = {
				"event": "trackEvent",
				"eventCategory": "contact",
				"eventAction": "submit"
			}

			var isValid = validateForm(contactFormFields);
			if(isValid == false){

				trackData["eventLabel"] = "error";
				trackData["eventValue"] = "contact form validation error";
				window.dataLayer.push(trackData);

				$('html, body').animate({
					  scrollTop: $('.form-item-nom').parent().offset().top - 200 + 'px'
				  }, 500);
			} else {

				trackData["eventLabel"] = "success";
				trackData["eventValue"] = "contact form validation success";
				window.dataLayer.push(trackData);

				webformSubmissionFlag = true;
				this.submit();
			}
		}
	});


	if($('.webform-confirmation__message').length){
		$('.legal_text').hide();
		$('.contact_info_row').addClass('success');
	}

	function validateUser(target){
		var isValid = true;
		target.each(function(i, el) {
 			var el = $(this);
			var elVal = el.val();

			// Clear all feedback messages for the current field
			validate_clearFieldMessages(el);

			if(el.attr('name') == 'name') {
				if( el.val().match(userNameCheck) || isEmail(el.val()) ) {
					validate_setValid(el);
				} else {
					validate_setInvalidError(el);
					isValid = false;
				}
			}
			// Check required fields
			if(el.attr('required') == 'required' && elVal == "") {
				validate_setRequiredError(el);
				isValid = false;
			}
		})

		return isValid;
	}

	//user sign in
	$('.user-login-form .required').change(function(){
		var inputs = $(this);
		inputs.parent().children('.alert-sm').empty();
		validateUser(inputs);
	});

	$('.user-login-form .form-submit').click(function(event){
		var inputs = $('.user-login-form .required');
		var isValid = validateUser(inputs);
		console.log(validateUser(inputs));
		if(isValid == false){
			event.preventDefault();
		};
	});

	$('.user-login-form .form-submit').keypress(function(event){
		if(event.which == 13){
			var inputs = $('.user-login-form .required');
			var isValid = validateUser(inputs);
			console.log(validateUser(inputs));
			if(isValid == false){
				event.preventDefault();
			};
		}
	});

	//user forgot password
	$('.user-pass .required').change(function(){
		var inputs = $(this);
		inputs.parent().children('.alert-sm').empty();
		validateUser(inputs);
	});

	$('.user-pass #edit-submit').click(function(event){
		var inputs = $('.user-pass .required');
		var isValid = validateUser(inputs);
		console.log(validateUser(inputs));
		if(isValid == false){
			event.preventDefault();
		};
	});

	$('.user-pass #edit-submit').keypress(function(event){
		if(event.which == 13){
			var inputs = $('.user-pass .required');
			var isValid = validateUser(inputs);
			console.log(validateUser(inputs));
			if(isValid == false){
				event.preventDefault();
			};
		}
	});

 	//user profile edit
 	$('.update_user_form .required').change(function(){
 		var inputs = $(this);
 		inputs.each(function(i, el){
 			var el = $(this);
 			var elVal = el.val();
 			if(isEmpty(elVal)){
 				el.parent().removeClass('valid_input invalid_input').addClass('required_input');
				el.parent().children('.error_msg').empty().append(errorMessage[0]);
 			}else if( el.hasClass('form-text') && !elVal.match(nameCheck)){
 				el.parent().removeClass('valid_input required_input').addClass('invalid_input');
				el.parent().children('.error_msg').empty().append(errorMessage[1]);
 			}else if( el.hasClass('form-email') && !isEmail(elVal)){
 				el.parent().removeClass('valid_input required_input').addClass('invalid_input');
				el.parent().children('.error_msg').empty().append(errorMessage[1]);
 			}
 			else{
 				el.parent().removeClass('invalid_input required_input').addClass('valid_input');
 				el.parent().children('.error_msg').empty()
				$('.update_user_form').submit();
 			}
 		})
 	});

 	$('.update_user_form .form-tel').change(function(){
		var tel = $(this);
		var telVal = tel.val();
		if(isEmpty(telVal)){
			tel.parent().removeClass('invalid_input valid_input');
			tel.parent().children('.error_msg').empty();
		}else if( !telVal.match(telCheck)){
			tel.parent().removeClass('valid_input').addClass('invalid_input');
			tel.parent().children('.error_msg').empty().append(errorMessage[1]);
		}
		else{
			tel.parent().removeClass('invalid_input required_input').addClass('valid_input');
			tel.parent().children('.error_msg').empty();
			$('.update_user_form').submit();
		}
	});

	$('.newsletter_check').change(function(){
		var checkBox = $(this).children('input');
		if(checkBox.is(':checked')){
			checkBox.val('on');
			console.log(checkBox.val());
		}else{
			checkBox.val('off');
			console.log(checkBox.val());
		}
		$('.update_user_form').submit();
	});

 	//modify password

 	function validateMp(target){
		var isValid = true;
		target.each(function(i, el) {
 			var el = $(this);
			var elVal = el.val();

			// Clear all feedback messages for the current field
			validate_mp_clearFieldMessages(el);

			if(el.attr('name') == 'password_confirm[pass2]') {
				if( el.val() == $('#edit-password-confirm-pass1').val() ) {
					validate_mp_setValid(el);
					validate_mp_setValid($('#edit-password-confirm-pass1'));
				} else {
					validate_mp_setInvalidError(el);
					isValid = false;
				}
			}
			// Check required fields
			if(el.attr('type') == 'password' && elVal == "") {
				validate_mp_setRequiredError(el);
				isValid = false;
			}
		})

		return isValid;
	}

	$('#edit-password-confirm-pass1').click(function(){
 		var input = $(this);
		validate_mp_clearFieldMessages(input);
	});

 	$('#edit-password-confirm-pass1').focusout(function(){
 		var input = $(this);
		var inputVal = input.val();
		validate_mp_clearFieldMessages(input);
		if( isEmpty(inputVal)){
			validate_mp_setRequiredError(input);
		}else if( $('#edit-password-confirm-pass2').val() && (input.val() !== $('#edit-password-confirm-pass2').val()) ){
			validate_mp_setInvalidError($('#edit-password-confirm-pass2'));
		}else{
			validate_mp_setValid(input);
		}
 	});

	$('#edit-password-confirm-pass2').focusout(function(){
		var input = $(this);
		validateMp(input)
	});

	$('.submit_modify_pass').click(function(event){
		var input = $('.modify_user_pass input[type="password"]');
		if(validateMp(input) == false){
			event.preventDefault();
		}
	});

	$('.user-pass-reset .form-submit').click(function(event){
		var input = $('.user-pass-reset input[type="password"]');
		if(validateMp(input) == false){
			event.preventDefault();
		}
	});

	$('.msg_row .close').click(function(){
		$(this).closest('.msg_row').removeClass('alert-danger alert-success');
	});

	$('.update_user_form').submit(function(event) {

		// Store user identification keys.
		// namfi_user object is exposed in the template by Drupal
		var formData = {
			'uid': namfi_user.uid,
			'hash': namfi_user.hash
		};

		// Field names mapping, between Drupal expected names (left) and template names (right)
		// This should be refactorized, as names should be consistent everywhere.
		var formFields = {
			'field_firstname': 'firstname',
            'field_lastname': 'lastname',
            'field_phone': 'telephone',
            'mail': 'email',
            'field_user_newsletter': 'newsletter'
		};

		// Only store modified fields
		for(let key in formFields) {
			let el = $('input[name="' + formFields[key] + '"]');
			let elValue = el.val();
			if (el && namfi_user.hasOwnProperty(key) && elValue !== namfi_user[key]) {
				formData[key] = elValue;
			}
		}

        $.ajax({
            type        : 'POST',
            url         : '/api/user/field',
            data        : formData,
            dataType    : 'json',
            encode      : true
	        })

	        .done(function(data) {

		        if (data.success) {
					for(let key in data.success) {
						// Apply valid class to fields
						let el = $('input[name="' + formFields[key] + '"]');
						validate_clearFieldMessages(el);
						validate_setValid(el);

						// Update namfi_user reference object with newly set data
						// ###TODO
						// namfi_user {}
					}
				}

				if(data.error) {
					for(let key in data.error) {
						// Do not consider 'Identical values' feedback as error,
						// although we should fix the ###TODO above to avoid this case
						if(data.error[key] != 'Identical values') {
							// Apply error class to fields
							let el = $('input[name="' + formFields[key] + '"]');
							validate_clearFieldMessages(el);
							validate_setInvalidError(el);
						}
					}
				}
	        })

	        .fail(function(data) {

	 			$('.update_user_form input.form-control').parent().removeClass('valid_input');
				$('.update_user_form input.form-control').parent().addClass('invalid_input');
				console.log(data);
		    });

	        event.preventDefault();

	});

    $('.modify_user_pass').submit(function(event) {

		// Store user identification keys.
		// namfi_user object is exposed in the template by Drupal
        var formData = {
			'uid': namfi_user.uid,
			'hash': namfi_user.hash,
            'password'        : $('#edit-password-confirm-pass2').val()
		};

        $.ajax({
            type        : 'POST',
            url         : '/api/user/field',
            data        : formData,
            dataType    : 'json',
            encode      : true
	        })

        .done(function(data) {

	        if (data.success) {
				console.log("PASSWORD UPDATE SUCCESS: ", data.success);
		        if (data.success) {


					// ###TODO : provide user feedback. Close password modal ?
					$('#modifyPassModal').modal('hide')
					for(let key in data.success) {
						/*
						// Apply valid class to fields
						let el = $('input[name="' + formFields[key] + '"]');
						validate_clearFieldMessages(el);
						validate_setValid(el);
						*/
					}
				}

			}

			if(data.error) {
				console.log("PASSWORD UPDATE ERROR: ", data.error);
				var input = $('.modify_user_pass .form-text');
				validate_mp_clearFieldMessages(input);
				input.parent().addClass('invalid_input');
				$('.modify_user_pass .msg_row').addClass('alert-danger');
				$('.modify_user_pass .msg_row_msg').append(errorMessage[3]);
			}

        })

        .fail(function(data) {
        		var input = $('.modify_user_pass .form-text');
				validate_mp_clearFieldMessages(input);
				input.parent().addClass('invalid_input');
				$('.modify_user_pass .msg_row').addClass('alert-danger');
				$('.modify_user_pass .msg_row_msg').append(errorMessage[3]);
			console.log(data);
	    });

        event.preventDefault();

	});

	/**
	 *
	 * DataLayer
	 *
	 */
	function datalayer_track(target) {
		// data is stored in a data-datalayer attribute, on target element
		let rawData = $(target).data('datalayer');
		let data = {
				'event': 'trackEvent'
			};

		// Parse target data and add to 'data' object
		for(let rawKey in rawData) {
			let key = 'event' + rawKey.charAt(0).toUpperCase() + rawKey.slice(1);
			data[key] = rawData[rawKey];
		}

		console.log("Datalayer: ", data);

		// Push data into datalayer
		window.dataLayer.push(data);
	}

	window.dataLayer = window.dataLayer || [];
	// Bind on all elements with data-datalayer attribute
	$('[data-datalayer]').click(function() {
		datalayer_track(this);
	});


});

// end jquery


// custom select

var x, i, j, selElmnt, a, b, c;
/*look for any elements with the class "custom-select":*/
x = document.getElementsByClassName("select-wrapper");
for (i = 0; i < x.length; i++) {
  selElmnt = x[i].getElementsByTagName("select")[0];
  /*for each element, create a new DIV that will act as the selected item:*/
  a = document.createElement("DIV");
  a.setAttribute("class", "select-selected form-control");
  a.innerHTML = selElmnt.options[selElmnt.selectedIndex].innerHTML;
  x[i].appendChild(a);
  /*for each element, create a new DIV that will contain the option list:*/
  b = document.createElement("DIV");
  b.setAttribute("class", "select-items select-hide");
  for (j = 1; j < selElmnt.length; j++) {
    /*for each option in the original select element,
    create a new DIV that will act as an option item:*/
    c = document.createElement("DIV");
    c.innerHTML = selElmnt.options[j].innerHTML;
    c.addEventListener("click", function(e) {
        /*when an item is clicked, update the original select box,
        and the selected item:*/
        var y, i, k, s, h;
        s = this.parentNode.parentNode.getElementsByTagName("select")[0];
        h = this.parentNode.previousSibling;
        for (i = 0; i < s.length; i++) {
          if (s.options[i].innerHTML == this.innerHTML) {
            s.selectedIndex = i;
            h.innerHTML = this.innerHTML;
            y = this.parentNode.getElementsByClassName("same-as-selected");
            for (k = 0; k < y.length; k++) {
              y[k].removeAttribute("class");
            }
            this.setAttribute("class", "same-as-selected");
            break;
          }
        }
        h.click();
    });
    b.appendChild(c);
  }
  x[i].appendChild(b);
  a.addEventListener("click", function(e) {
      /*when the select box is clicked, close any other select boxes,
      and open/close the current select box:*/
      e.stopPropagation();
      closeAllSelect(this);
      this.nextSibling.classList.toggle("select-hide");
      this.classList.toggle("select-arrow-active");
  });
}
function closeAllSelect(elmnt) {
  /*a function that will close all select boxes in the document,
  except the current select box:*/
  var x, y, i, arrNo = [];
  x = document.getElementsByClassName("select-items");
  y = document.getElementsByClassName("select-selected");
  for (i = 0; i < y.length; i++) {
    if (elmnt == y[i]) {
      arrNo.push(i)
    } else {
      y[i].classList.remove("select-arrow-active");
    }
  }
  for (i = 0; i < x.length; i++) {
    if (arrNo.indexOf(i)) {
      x[i].classList.add("select-hide");
    }
  }
}
/*if the user clicks anywhere outside the select box,
then close all select boxes:*/

var element = document.querySelector('.input_box div');
if(element && element.classList.contains('custom-select')){
	document.addEventListener("click", closeAllSelect);

	document.addEventListener("change", function(event) {
	  let element = event.target;
	  if (element && element.matches(".form-element-field")) {
	    element.classList[element.value ? "add" : "remove"]("-hasvalue");
	  }
	});
};

document.addEventListener("DOMContentLoaded", function() {
  var webformConfirmation = document.getElementById('webform-confirmation');
  if(webformConfirmation) {
    webformConfirmation.scrollIntoView(true);
  }
});

